import React, { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { CommonButton } from '@/components/common'
import { Footer } from '@/components/layout'
import { LogoImg } from '@/components/layout/styled'
import { TENANT_TOPBAR_CONFIGS } from '@/constants'
import { useTenantContext } from '@/context/TenantContext'

export const ChairpersonAuthLayout = () => {
  const { tenant } = useTenantContext()

  const tenantLogo = useMemo(() => {
    return TENANT_TOPBAR_CONFIGS[tenant?.portal_theme]?.logo
  }, [tenant])

  const onBack = () => {
    window.history.back()
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header - same style as donor */}
      <Box
        component='header'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '5px 15px',
        }}
      >
        <a href={tenantLogo?.href} aria-label='Home'>
          <LogoImg
            src={tenantLogo?.src}
            alt={tenantLogo?.alt}
            sx={{
              maxWidth: { xs: '130px', md: tenantLogo?.maxWidth },
            }}
          />
        </a>

        <Box
          sx={{
            marginLeft: 'auto',
            display: 'inline-flex',
            gap: { xs: 1, md: 2 },
            alignItems: 'center',
          }}
        >
          <CommonButton
            id='header-go-back'
            label='Go Back'
            color='primary'
            variant='primary'
            onClick={onBack}
          />
        </Box>
      </Box>

      {/* Main Content */}
      <Box
        component='main'
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.50',
          p: 2,
        }}
      >
        <Outlet />
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  )
}
